/**
 * List of effect names that are added during the form creation
 */
export enum UnicEffectsAvailableEnum {
    JobsiteLoadAddressModifyEffects = 'JobsiteLoadAddressModifyEffects',
    JobsiteLoadAddressEffects = 'JobsiteLoadAddressEffects',
    PurchaseOrderRMSMandatoryEffects = 'PurchaseOrderRMSMandatoryEffects',
    PurchaseOrderMandatoryEffects = 'PurchaseOrderMandatoryEffects',
    JobsitePlantDefaultEffects = 'JobsitePlantDefaultEffects',
    JobsitePlantEffects = 'JobsitePlantEffects',
    JobsiteRadiusRenderMapEffects = 'JobsiteRadiusRenderMapEffects',
    JobsiteRenderMapEffects = 'JobsiteRenderMapEffects',
    PointOfDeliveryRadiusRenderMapEffects = 'PointOfDeliveryRadiusRenderMapEffects',
    PointOfDeliveryRenderMapEffects = 'PointOfDeliveryRenderMapEffects',
    ReceivingPersonsCustomerLoadEffects = 'ReceivingPersonsCustomerLoadEffects',
    AlternativeUnitsEffects = 'AlternativeUnitsEffects',
    UnitsEffects = 'UnitsEffects',
    ReceivingPersonsLoadEffects = 'ReceivingPersonsLoadEffects',
    TimeWindowsEffects = 'TimeWindowsEffects',
    TimeWindowsFromPlantEffects = 'TimeWindowsFromPlantEffects',
}

export const NGRX_EFFECTS_PROPS_KEY = '__@ngrx/effects__';
